// Espelho da rota (REQ-FE-003): a URL é a fonte de verdade; o store só reflete o contexto ativo para hooks e UI.
import { create } from 'zustand';

export interface ActiveContextState {
  readonly userId: string | null;
  readonly isNetworkScope: boolean;
  readonly activeTenantCode: string | null;
  readonly activeTenantId: string | null;
  readonly activeSiteId: string | null;
  readonly activeStudyCode: string | null;
}

export interface ContextStore extends ActiveContextState {
  readonly mirror: (next: Partial<ActiveContextState>) => void;
  readonly selectSite: (siteId: string | null) => void;
  readonly reset: () => void;
}

const initialState: ActiveContextState = {
  userId: null,
  isNetworkScope: false,
  activeTenantCode: null,
  activeTenantId: null,
  activeSiteId: null,
  activeStudyCode: null,
};

export const useContextStore = create<ContextStore>((set) => ({
  ...initialState,
  mirror: (next) => {
    set((state) => ({ ...state, ...next }));
  },
  selectSite: (siteId) => {
    set({ activeSiteId: siteId });
  },
  reset: () => {
    set(initialState);
  },
}));

/** Chave estável do contexto ativo (para propósito/caches por contexto). */
export function contextKey(state: ActiveContextState): string {
  if (state.isNetworkScope) {
    return 'network';
  }
  return [state.activeTenantCode ?? '-', state.activeStudyCode ?? '-'].join('/');
}
